import React from "react"
import PricingTld from "../ui/PricingTld"
import CurrencyContext from "../../context/CurrencyContext"
import { useStaticQuery, graphql } from "gatsby"
const InPrice = () => {
  const allData = useStaticQuery(graphql`
    query {
      allTldsPricingJson(filter: { tld: { eq: ".in" } }) {
        edges {
          node {
            tld
            slug
            pricing {
              INR {
                prefix
                suffix
                register
                renew
              }
              MYR {
                prefix
                suffix
                register
                renew
              }
              SGD {
                prefix
                suffix
                register
                renew
              }
              USD {
                prefix
                suffix
                register
                renew
              }
              GBP {
                prefix
                suffix
                register
                renew
              }
            }
          }
        }
      }
    }
  `)
  const tldPrice = allData.allTldsPricingJson.edges
  if (tldPrice.length <= 0) {
    return <></>
  }
  return (
    <>
      <CurrencyContext.Consumer>
        {(context) => {
          return (
            <>
              {tldPrice.map((item, index) => (
                <div key={index}>
                  <PricingTld pricing={item.node.pricing} tld={item.node.tld} />
                </div>
              ))}
            </>
          )
        }}
      </CurrencyContext.Consumer>
    </>
  )
}

export default InPrice
